import { useModal } from "../ModalProvider";
import { ReactNode } from "react";
import styled from "styled-components";

type ModalFullWindowProps = {
	children: ReactNode;
};

const ModalFullWindowWrapper = styled.div`
	position: relative;
	display: flex;
	border-radius: 8px;
	height: 100%;
	width: 100%;
`;

const ModalFullWindowChildren = styled.div`
	height: 100%;
	width: 100%;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	padding: 2rem;
	flex: 1;

	border-radius: 1rem;
`;

export const ModalFullWindow = ({
	children,
	...props
}: ModalFullWindowProps) => {
	const { closeModal } = useModal();

	const handleClick = () => {
		closeModal();
	};

	return (
		<ModalFullWindowWrapper {...props} onClick={handleClick}>
			<ModalFullWindowChildren>{children}</ModalFullWindowChildren>
		</ModalFullWindowWrapper>
	);
};
